export default __webpack_public_path__ + "static/media/gie.d9365bd9.png";